import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatCardModule } from '@angular/material/card'
import { PipesModule } from '@mmx/pipes'
import { TranslateModule } from '@ngx-translate/core'

import { ActionCardModule } from '../action-card'
import { LocationWorkingHoursModule } from '../location-working-hours'
import { LocationPickerComponent } from './location-picker.component'

@NgModule({
  imports: [
    ActionCardModule,
    CommonModule,
    FlexLayoutModule,
    TranslateModule,
    MatCardModule,
    LocationWorkingHoursModule,
    PipesModule,
  ],
  exports: [
    LocationPickerComponent,
  ],
  declarations: [
    LocationPickerComponent,
  ],
  providers: [],
})
export class LocationPickerModule { }
